import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { KPI } from '../../../@core/api';
import { UsersService } from '../../../@core/utils';
import { UsernamePipe } from '../../pipes';
import { HistoryChangesListComponent } from '../history-changes-list/history-changes-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbPopoverModule } from '@nebular/theme';
import { DatePipe } from '@angular/common';

export interface ChangeItemGrouped {
  object_type: string;
  object_id: number;
  changes: KPI.ChangeItem[];
}

interface HistoryItemGrouped {
  user: KPI.User;
  date: Date;
  titleDisplayed: string;
  changesGrouped: ChangeItemGrouped[];
}

@Component({
    selector: 'app-history-list',
    styleUrls: ['./history-list.component.scss'],
    templateUrl: './history-list.component.html',
    standalone: true,
    imports: [
    NbPopoverModule,
    FontAwesomeModule,
    HistoryChangesListComponent,
    DatePipe,
    TranslateModule
],
})
export class HistoryListComponent implements OnChanges, OnDestroy {
  @Input() public history: KPI.History;

  private users: KPI.User[];

  private subscriptions: Subscription[] = [];

  public groupHistoryItems: HistoryItemGrouped[] = [];

  constructor(
    private usernamePipe: UsernamePipe,
    private usersService: UsersService,
    private translate: TranslateService,
  ) { }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public ngOnChanges(): void {
    this.subscriptions.push(
      this.usersService.allUsers$.subscribe((users) => {
        this.users = users;
        this.groupHistoryItems = this.groupHistoryByTypeAndId(this.history.history_items);
        this.groupHistoryItems.sort((group1, group2) => group2.date.getTime() - group1.date.getTime());
      }),
    );
  }

  /**
   * Groups the changes in the history item by object_Type and objecet_id
   *
   * @param historyItems
   */
  private groupHistoryByTypeAndId(historyItems: KPI.HistoryItem[]): HistoryItemGrouped[] {
    const groupHistoryItems: HistoryItemGrouped[] = [];

    for (const historyItem of historyItems) {

      const changesGroupMap: { [key: string]: ChangeItemGrouped } = {};

      const translationKey = historyItem.isCreation
        ? _('theme.history-list.created_by') : _('theme.history-list.modified_by');

      const user = this.users.find(usr => usr.get_user_id === historyItem.user);
      const username = this.usernamePipe.transform(user);
      const titleDisplayed = this.translate.instant(translationKey, { user: username });

      const historyItemGroup: HistoryItemGrouped = {
        user,
        date: new Date(historyItem.date),
        titleDisplayed,
        changesGrouped: [],
      };
      for (const change of historyItem.changes) {
        const key = `${change.object_type}_${change.object_id}`;
        const changeItemGrouped =
          changesGroupMap[key] ||
          {
            object_type: change.object_type,
            object_id: change.object_id,
            changes: [],
          }
          ;
        changeItemGrouped.changes.push(change);
        changesGroupMap[key] = changeItemGrouped;
      }
      historyItemGroup.changesGrouped = Object.values(changesGroupMap);
      groupHistoryItems.push(historyItemGroup);
    }
    return groupHistoryItems;
  }
}
